import { Box, Typography } from "@mui/material";
import axios from "axios";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import rockAndRoll from "../../../../../../../../../../assets/images/rock-and-roll/rock-and-roll.png";
import { node_server } from "../../../../../../../../../../constants";
import { useTheme } from "../../../../../../../../../../context/themeContext";
import styles from "./style.module.css";

function truncateText(text, maxLength) {
	if (text.length <= maxLength) {
		return text;
	} else {
		return text.slice(0, maxLength) + "...";
	}
}

function Top({ data }) {
	const { theme } = useTheme();
	const user = useSelector((state) => state.user.value);
	const location = useLocation();
	const [gaveShoutOut, setGaveShoutOut] = useState(true);

	const cancelShoutOut = async () => {
		if (gaveShoutOut) {
			const response = await axios.post(
				`${node_server}/api/shoutouts/cancel`,
				{
					receiverId: data.receiver_id,
				},
				{
					withCredentials: true,
				},
			);
			if (response.status === 200) {
				setGaveShoutOut(false);
			}
		}
	};

	const handleShoutOutClick = async () => {
		if (location.pathname !== "/profile") return;
		if (gaveShoutOut) {
			cancelShoutOut();
			return;
		}
		const response = await axios.post(
			`${node_server}/api/shoutouts/give`,
			{
				receiverId: data.receiver_id,
			},
			{
				withCredentials: true,
			},
		);
		if (response.status === 200) {
			setGaveShoutOut(true);
		}
	};

	return (
		<Box className={styles.top}>
			<Box className={styles.profile}>
				<Box
					className={styles.image}
					sx={{
						backgroundImage: `url(${data.profile_image})`,
						width: "32px",
						height: "32px",
						backgroundSize: "cover",
						backgroundRepeat: "no-repeat",
						backgroundPosition: "center center",
					}}
				></Box>
				<Box className={styles.name}>
					<Typography
						variant="h6"
						sx={{
							color: theme.palette.darkgrey.darkgrey600,
						}}
					>
						{truncateText(data.real_name, 5)}
					</Typography>
					<Typography
						variant="body2"
						sx={{
							color: theme.palette.darkgrey.darkgrey300,
						}}
					>
						{data.nick_name}
					</Typography>
				</Box>
			</Box>
			<Box
				onClick={handleShoutOutClick}
				className={styles.Shouts}
				sx={{
					bgcolor: gaveShoutOut
						? theme.palette.warning.main
						: theme.palette.darkgrey.darkgrey400,
				}}
			>
				<img
					src={rockAndRoll}
					width="100%"
					height="100%"
					alt="rock-and-roll"
				/>
			</Box>
		</Box>
	);
}

export default Top;
